import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * معالج التمرير الذكي (Smart Scroll Restoration)
 * يعيد التمرير إلى الأعلى فقط عند تغير المسار الفعلي (Pathname)
 * ويحافظ على موضع التمرير عند تغيير الفلاتر أو التبويبات أو معلمات الاستعلام.
 */
export function useSmartScrollRestoration(containerRef?: React.RefObject<HTMLElement | null>) {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    if (prevPathRef.current !== location.pathname) {
      prevPathRef.current = location.pathname;
      if (containerRef?.current) {
        containerRef.current.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
      } else {
        window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
      }
    }
  }, [location.pathname, containerRef]);
}

/**
 * مغلّف انتقال الصفحات الناعم (Smooth Page Transition Container)
 * يضمن ثبات التخطيط وعدم الرعشة دون تأخير زمني إضافي.
 */
export function PageTransition({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={`page-content-wrapper ${className}`.trim()}>
      {children}
    </div>
  );
}

/**
 * دالة تفريغ وتحضير المكونات والبيانات باللمس والتحويم السريع
 */
const prefetchDebounceTimers = new Map<string, number>();

export function debouncedPrefetch(key: string, prefetchFn: () => void, delay = 35): void {
  if (prefetchDebounceTimers.has(key)) {
    window.clearTimeout(prefetchDebounceTimers.get(key));
  }
  const timer = window.setTimeout(() => {
    prefetchDebounceTimers.delete(key);
    prefetchFn();
  }, delay);
  prefetchDebounceTimers.set(key, timer);
}
